import { LOCAL__grid2d_upsert } from '@/state/grid2d/grid2d/LOCAL__grid2d_upsert';
import { store } from '@/state/store';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { try_upsert_from_generation_to_user_task_grid2d_chunk } from '../../_methods/user_task/try_upsert_from_generation_to_user_task_grid2d_chunk';
import { FN_GRID2D_CELL__try_set_image } from './_methods/FN_GRID2D_CELL__try_set_image';

export function HANDLER_CLIENT__grid2d_upsert(items: any) {
  assert_array_instanceof(items, DTO__grid2d);

  for (let grid2d of items) {
    let cells = grid2d.cells__get_loaded();
    cells.map(FN_GRID2D_CELL__try_set_image);
  }

  items.forEach(grid2d_dto => grid2d_dto.on_grid2d_updated());

  store.dispatch(LOCAL__grid2d_upsert(items));

  items.forEach(try_upsert_from_generation_to_user_task_grid2d_chunk);
}
